import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const CollegePrivateRoute = ({}) => {
  const uType = useSelector((state) => state.uType);
  return uType === "college" ? <Outlet /> : <Navigate to="/College/Login" />;
};

export default CollegePrivateRoute;
